// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","loading":"App_loading__Z10nZ","title":"App_title__YS7Xx","error":"App_error__7hurn","mainTitle":"App_mainTitle__ZQVGW"};